module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-Light-a7330303092293642335ff9b7460edfb.svg";